import { render, staticRenderFns } from "./campaign-creator-header.vue?vue&type=template&id=4035e883&scoped=true&"
import script from "./campaign-creator-header.vue?vue&type=script&lang=js&"
export * from "./campaign-creator-header.vue?vue&type=script&lang=js&"
import style0 from "./campaign-creator-header.vue?vue&type=style&index=0&id=4035e883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035e883",
  null
  
)

export default component.exports